module.exports = "/_next/static/images/hirehac-logo-680fd0bc5aaf7a4d40f6dfc1ba9478d5.png";